import { Pipe, PipeTransform } from '@angular/core';

const PARTNER_NAME_MAP: Record<string, string> = {
  playsight: 'Playsight',
  tracktennis: 'Track.Tennis',
  savemyplay: 'Save My Play',
  microframe: 'Microframe Sports',
};

@Pipe({
  name: 'partnerName',
  standalone: true,
})
export class PartnerNamePipe implements PipeTransform {
  transform(partner?: string | null): string {
    if (!partner) {
      return '';
    }

    const normalizedPartner = partner.trim().toLowerCase();
    return PARTNER_NAME_MAP[normalizedPartner] ?? partner;
  }
}

